import { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';
import { STORAGE_KEYS } from '../config';
import Logo from '../components/logo';
import { db, analytics } from '../utils/firebase';
import { onValue, ref } from 'firebase/database';
import usePushNotification from '../hooks/usePushNotification';
import useAuth from '../hooks/useAuth';
import useSaveToken from '../hooks/useSaveToken';
import httpClient from '../http-client';
import { logEvent } from "firebase/analytics";
import { ANALYTICS_EVENTS } from '../constants/analytics';


export default function WalkinPage() {
  const { companyId } = useParams();
  // TODO: verify that companyID exists, if not redirect to home or 404
  const effectRanOnce = useRef(false);
  const [serviceList, setServiceList] = useState<string[]>([]);
  const [locationName, setLocationName] = useState<string | undefined>();

  const fcmToken = usePushNotification();

  
  const { loading, userId, authUser } = useAuth();

  useSaveToken(companyId!, userId!, fcmToken!);

  useEffect(() => {
    if (effectRanOnce.current === false && companyId) {
      const dbRef = ref(db, `ServiceList/${companyId}`);

      onValue(
        dbRef,
        (snapshot) => {
          let services: string[] = [];
          snapshot.forEach((childSnapshot) => {
            services.push(childSnapshot.val());
          });

          if (services.length === 0) {
            // add default service
            services = services.concat([
              "Women's Haircut/Style",
              "Men's Haircut/Style",
              'Eyebrows/Eyelashes',
              'Facials',
              'Massage',
              'Mani/Pedi',
              'Med Spa',
              'Waxing',
              'Teeth Whitening',
              'Body Contouring',
            ]);
          }

          setServiceList(services);
        },
        {
          onlyOnce: true,
        }
      );

      return () => {
        effectRanOnce.current = true;
      };
    }
  }, [companyId]);

  useEffect(() => {
    if (companyId) {
      httpClient.get('/v1/getUserIdByCompanyId/' + companyId).then((response) => {
        window.localStorage.setItem(STORAGE_KEYS.COMPANY_NAME, response.data.split('-')[1]);
      });
      httpClient.get('/v1/getCompanyLocations/' + companyId).then((response) => {
        const locationName = response.data?.[0]?.Name;
        if (locationName) {
          setLocationName(locationName)
        }
      });
      
    }
  }, [companyId]);

  const saveSelectedService = () => {
    window.sessionStorage.setItem(STORAGE_KEYS.SELECTED_SERVICE, selectedService!);
    navigate(`/${companyId}/user-info`);
  };

  const navigate = useNavigate();
  const [showError, setShowError] = useState(false);
  const [selectedService, setSelectedService] = useState<string>();

  const buttonStyle =
    'flex justify-center w-full text-2xl border border-gray-300 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg p-2.5 mb-5';
  const buttonErrorStyle = showError && 'border-red-300';

  const submitButtonStyle = 'bg-blue-700 text-white text-2xl p-2.5 rounded-full mb-5 w-3/4 md:w-2/4 fixed bottom-0';

  const buttonSelectedStyle = (service: string) => {
    return selectedService === service && 'bg-blue-700 text-white';
  };

  const handleNextPress = async () => {
    // Use for running script to add service to SP
    // addService('316', ['Adult haircut', 'Kids haircut', 'Beard', 'Eyebrows', 'Edge up']);
    if (!selectedService) {
      return setShowError(true);
    }
    logEvent(analytics, ANALYTICS_EVENTS.WALK_IN_NEXT_PRESSED, {
      service: selectedService,
      company_id: companyId,
      user_id: userId,
      auth_user_id: authUser!.uid
    });
    saveSelectedService();
  };

  const onServiceClick = (service: string) => {
    console.log('**************** selecting service ****************', service);
    setShowError(false);
    logEvent(analytics,ANALYTICS_EVENTS.WALK_IN_SERVICE_SELECTED, {
      service,
      company_id: companyId,
      user_id: userId,
      auth_user_id: authUser!.uid
    });
    setSelectedService(service);
  };

  if (serviceList.length === 0) {
    return null;
  }

  return (
    <>
      <div className='flex flex-col text-center mb-10 items-center'>
        <Logo companyId={companyId!}></Logo>
        <h1 className='text-4xl'>Walk ins</h1>
        <p className='text-2xl'>Select your service</p>
        <hr className='h-px w-36 mx-auto border-0 my-4 bg-gray-300' />
        {/* {locationName && <p className='text-xl'>{locationName}</p>} */}
      </div>

      <div className='mx-auto flex flex-col w-3/4 md:w-2/4 pb-20'>
        {serviceList.map((service) => (
          <button
            key={service}
            type='button'
            className={twMerge(buttonStyle, buttonErrorStyle, buttonSelectedStyle(service))}
            onClick={() => onServiceClick(service)}
          >
            {service}
          </button>
        ))}

        {showError === true && (
          <div className='text-red-700 text-center text-2xl p-2.5'>Please select service</div>
        )}

        <button className={submitButtonStyle} onClick={handleNextPress}>
          Next
        </button>
      </div>
      {/* <PushNotificationToast></PushNotificationToast> */}
      {/* <CustomInstallApp></CustomInstallApp> */}
    </>
  );
}
